import { Schema, arrayOf } from 'normalizr';

export const manipulation = new Schema('manipulations');
export const arrayOfManipulations = arrayOf(manipulation);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/api/schema.js